import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteDemandSuppressionMaster,
  listDemandSuppressionMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要抑制計画マスタ 削除 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listDemandSuppressionMasters を invalidate してテーブルを最新化する。
 */
export function useDeleteDemandSuppressionMaster(): InvalidatingMutationResultFor<
  typeof deleteDemandSuppressionMaster
> {
  return useInvalidatingMutation(deleteDemandSuppressionMaster, [
    createConnectQueryKey({
      schema: listDemandSuppressionMasters,
      cardinality: 'finite',
    }),
  ])
}
